import { useNavigate } from "react-router-dom";
import UrlEncodeDecode from "../txsearchparams/urlEncodeDecode";

export default function useTxNavigate() {
    const navigate = useNavigate();

    const customNavigateFunction = (destination) => {
        let [finalDestination, query] = destination.split('?')
        if( query ) {
            finalDestination += `?${UrlEncodeDecode.STATE_NAME}=${UrlEncodeDecode.encode(query)}`
        }
        navigate(finalDestination)
    }

    return customNavigateFunction;
}